module.exports = __webpack_public_path__ + "static/media/Tseng_Eigencharacters_1128.84725706.pdf";